import { render, staticRenderFns } from "./manufacturingCreateEdit.vue?vue&type=template&id=00b4dea7&scoped=true"
import script from "./manufacturingCreateEdit.vue?vue&type=script&lang=js"
export * from "./manufacturingCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./manufacturingCreateEdit.vue?vue&type=style&index=0&id=00b4dea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b4dea7",
  null
  
)

export default component.exports